import { getFirstStringOrDefault } from 'lib/string';
import { IncomingHttpHeaders } from 'http';

export const getUserId = (headers: IncomingHttpHeaders): string =>
  getFirstStringOrDefault(headers ? headers['sp-internal-user-id'] : [], '');
